import React, { Component } from 'react';
import { connect } from 'react-redux';
import AdminWrapperRedirect from 'appSrc/components/Auth/AdminWrapperRedirect';
import Helmet from 'react-helmet';
import Router from './Router';
import moment from 'moment-timezone';
import style from './styles/style.module.css';

moment.tz.setDefault( 'America/Chicago' );

class DLTVAdmin extends Component {
    render() {
        return (
            <section className={ style.dltvAdminPanel }>
                <Helmet>
                    <title>Admin - DLTV</title>
                </Helmet>
                <Router />
            </section>
        );
    }
}

export default AdminWrapperRedirect( connect()( DLTVAdmin ) );
